import React, { useState, useEffect } from "react"
import { promotionsData } from "../../data/PromotionData"

export default function ModuleJustDoYourBest({ closeModal }) {
  const promoData = promotionsData.find(
    (promo) => promo.title === "JDB Exclusive Promo"
  )

  const [leaderboardData, setLeaderboardData] = useState([])
  const [loadingWeekly, setLoadingWeekly] = useState(true)
  const [loadingGrand, setLoadingGrand] = useState(true)
  const [loading, setLoading] = useState(true)
  const bonusByRank = {}

  // Top 1–3
  bonusByRank[1] = 120
  bonusByRank[2] = 100
  bonusByRank[3] = 80

  // Ranks 4–10
  for (let i = 4; i <= 10; i++) {
    bonusByRank[i] = 60
  }

  // Ranks 11–20
  for (let i = 11; i <= 20; i++) {
    bonusByRank[i] = 50
  }

  // Ranks 21–25
  for (let i = 21; i <= 25; i++) {
    bonusByRank[i] = 40
  }

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const url = `${process.env.REACT_APP_API_JSON_URL_PROMO}?cmd=getJDBLeaderboard`
        const response = await fetch(url)
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`)

        const rawData = await response.json()

        const parsedData = Object.entries(rawData).map(([ranking, value]) => {
          const parts = value.split(",")
          const username = parts[0]?.trim()
          const score = parts[1]?.split("|")[1]?.trim() || "0"

          return {
            ranking, // e.g. "1", "2", ...
            username, // e.g. "ANI**0032**"
            score, // e.g. "12345"
          }
        })

        setLeaderboardData(parsedData.slice(0, 25))
      } catch (err) {
        console.error("Error fetching leaderboard data:", err)
      } finally {
        setLoadingWeekly(false)
      }
    }

    fetchLeaderboardData()
  }, [])

  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>
        <div className="promotion-module-main">
          <div className="promotion-leaderboard">
            <div className="promotion-module-banner">
              <img src={promoData.imgSrc} alt="Promotion Banner" />
              <div className="img-overlay"></div>
            </div>

            {/* … earlier code omitted for brevity … */}
            <div className="king-of-reel-title">Leaderboard</div>
            <table
              className="promotion-module-table"
              style={{ marginTop: "5px" }}
            >
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Player ID</th>
                  <th>Prize (Free Spins)</th>
                </tr>
              </thead>
              <tbody>
                {loadingWeekly ? (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      Loading...
                    </td>
                  </tr>
                ) : leaderboardData.length > 0 ? (
                  leaderboardData.map((row, index) => {
                    let displayRank = row.ranking

                    if (displayRank === "1") {
                      displayRank = "🏆 1"
                    } else if (displayRank === "2") {
                      displayRank = "🏆 2"
                    } else if (displayRank === "3") {
                      displayRank = "🏆 3"
                    } else if (
                      Number(displayRank) >= 4 &&
                      Number(displayRank) <= 25
                    ) {
                      displayRank = `⭐ ${displayRank}`
                    }

                    const freeSpinValue = bonusByRank[row.ranking] || 0
                    const freeSpin = freeSpinValue
                      ? `${freeSpinValue.toLocaleString()}`
                      : "–"

                    return (
                      <tr key={index}>
                        <td>{displayRank}</td>
                        <td>{row.username || "---"}</td>
                        <td>{freeSpin}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="promotion-module-cta">
            <span style={{ fontSize: "13px", paddingInline: "10px" }}>
              Leaderboard changes in real-time until the final result on July 16
              (12PM) & JULY 31 (12PM)
            </span>
            <a href="/slots/?provider=JDB">
              <button className="promotion-module-leaderboard-btn">
                Play Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
